/**
 * Client Calendar V2 Module Entry Point
 * Exports the main client calendar component
 */

import ClientCalendarV2 from './ClientCalendarV2';

export default ClientCalendarV2;
